var styles = [".date-tip[_ngcontent-%COMP%]{margin-left:.2rem}"];
export { styles as styles };
